module.exports = __webpack_public_path__ + "img/nam.bb49a403.svg";